import { render, staticRenderFns } from "./ExportPDF.vue?vue&type=template&id=284f3328"
import script from "./ExportPDF.vue?vue&type=script&lang=ts"
export * from "./ExportPDF.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports